import { colorBaseGreyWarm100, layoutMarginSmall } from '@issuu/silkscreen';
import { trackMarketingEvent } from '@issuu/tracking-micro';
import React, { useContext, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';

const Root = styled.div`
    padding: ${layoutMarginSmall};
    width: 100%;
    min-height: calc(800px + ${layoutMarginSmall /* padding */} * 2);
    grid-area: sellwild;
    background-color: ${colorBaseGreyWarm100};
`;

// For not impact CWV, Time To Interactive in lighthouse, 8 sec is a safe number to apply
const DELAY_LOAD_TIMEOUT = 8000;
export const AdsSellwild: React.FC = () => {
    const { publisher } = useContext(DocumentContext);
    // sellwild needs a lowercase html tag https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
    const createMarkup = () => {
        return { __html: inView || triggered ? '<sellwild></sellwild>' : '' };
    };

    const [viewRef, inView] = useInView({ triggerOnce: true });
    const [triggered, setTriggered] = useState(false);
    useEffect(() => {
        // trigger sellwild script in head, based on free or paid
        trackMarketingEvent('set_paid_status', {
            is_paid_publisher: publisher.userPlan !== 'FREE',
        });

        // trigger sellwild element in page
        const triggerHandler = () => setTriggered(true);
        const timeoutId = setTimeout(triggerHandler, DELAY_LOAD_TIMEOUT);
        document.addEventListener('scroll', triggerHandler, { once: true, passive: true });
        return () => {
            document.removeEventListener('scroll', triggerHandler);
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <Root dangerouslySetInnerHTML={createMarkup()} data-testid="ads-sellwild" ref={viewRef} />
    );
};
